import { Component } from '@angular/core';

@Component({
  selector: 'wkt-building',
  templateUrl: './building.component.html',
  styleUrls: ['./building.component.scss'],
})
export class BuildingComponent {}
